<script setup>
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  class: { type: String, default: '' },
});
</script>

<template>
  <td
    :class="cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', props.class)"
  >
    <slot />
  </td>
</template>
